import { render } from "./VoitingProtocol.vue?vue&type=template&id=86fc17f8&scoped=true"
import script from "./VoitingProtocol.vue?vue&type=script&lang=js"
export * from "./VoitingProtocol.vue?vue&type=script&lang=js"

import "./VoitingProtocol.vue?vue&type=style&index=0&id=86fc17f8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86fc17f8"]])

export default __exports__